import { GOLD_ROUND_ROBIN_URL, ISH_MEETING_URL, JACK_MEETING_URL } from 'utils/calendarConstants';

export const GOLD_CAMPAIGN_SLUGS: readonly string[] = [
  'atombeam',
  'liquidpiston',
  'futurecardia',
  'bucks-bbq-v14',
];

export const isGoldCampaignSlug = (slug?: string | null): boolean =>
  !!slug && GOLD_CAMPAIGN_SLUGS.includes(slug);

interface SalesAgent {
  salesAgentFirstName?: string | null;
  salesAgentLastName?: string | null;
}

/**
 * Returns the meeting URL to surface for a Gold campaign visitor, or `null`
 * when the contact is owned by a PEA (any named owner that is NOT one of the
 * two designated Gold reps). PEA-owned contacts must not see the Gold meeting
 * card at all per product spec (PD-34124, Paige 2026-04-27).
 *
 * Routing matrix:
 *   Ishmael Badze   -> Ish's calendar
 *   Jack Marecki    -> Jack's calendar
 *   Any other named owner (PEA) -> null  (caller hides the card)
 *   Empty / missing owner (BDR pool, unassigned, unknown) -> Gold Round Robin
 */
export const resolveGoldMeetingUrl = (agent?: SalesAgent | null): string | null => {
  const first = agent?.salesAgentFirstName?.trim().toLowerCase();
  const last = agent?.salesAgentLastName?.trim().toLowerCase();

  if (first === 'ishmael' && last === 'badze') return ISH_MEETING_URL;
  if (first === 'jack' && last === 'marecki') return JACK_MEETING_URL;

  const isPeaOwned = !!(first || last);
  if (isPeaOwned) return null;

  return GOLD_ROUND_ROBIN_URL;
};
